module.exports = __webpack_public_path__ + "static/media/forwardArrowLight.35d11dd8.svg";